module.exports = __webpack_public_path__ + "static/media/picture-(12).570f47fc.JPG";